import ArticleCard from 'components/ArticleCard';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { above } from 'utils/mediaqueries';
import { mediaQueries } from 'config/theme/breakpoints';
import ratios from 'config/theme/ratios';
import styled from 'libs/styled';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

const Wrapper = styled('ul')`
    display: flex;
    flex-wrap: wrap;

    @supports (display: grid) {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;

        ${above.sm} {
            grid-template-columns: 1fr 1fr;
            gap: 24px;
        }

        ${above.md} {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
`;

const Article = styled('li')`
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;

    ${above.sm} {
        width: 50.5%;
        max-width: 50%;
        flex: 0 0 50%;
    }
    ${above.md} {
        width: 33.33%;
        max-width: 33.33%;
        flex: 0 0 33.33%;
    }

    @supports (display: grid) {
        width: auto !important;
        max-width: none !important;
        flex: none !important;
        min-width: 0;

        ${above.md} {
            &:nth-of-type(4n) {
                grid-column-start: 1;
                grid-column-end: 4;
            }
        }
    }
`;

const ArticleGridLayout = ({ articles = [] }) => {
    const isAboveMd = useAboveBreakpoint('md');

    if (!articles.length > 0) {
        return null;
    }

    return (
        <MaxWidthWrapper includeContentMargins mt={['48px', null, '64px']}>
            <Wrapper>
                {articles.map((article, index) => {
                    const { backgroundLandscape, backgroundPortrait, date, heading, id, category, to } = article;
                    const wideArticleCard = isAboveMd && (index + 1) % 4 === 0; // Every fourth card

                    return (
                        <Article key={id}>
                            <ArticleCard
                                category={category}
                                date={date}
                                heading={heading}
                                image={wideArticleCard ? backgroundLandscape : backgroundPortrait}
                                mediaQuery={wideArticleCard ? mediaQueries.fullWidth : mediaQueries.threeColumn}
                                ratio={wideArticleCard ? ratios.horizontal : ratios.vertical}
                                to={to}
                            />
                        </Article>
                    );
                })}
            </Wrapper>
        </MaxWidthWrapper>
    );
};

ArticleGridLayout.propTypes = {
    articles: PropTypes.array,
};

export default ArticleGridLayout;
